import { Check, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { PREFAB_BENEFITS, PREFAB_CATEGORIES, whatsappHref } from "../data/site";

export const Prefab = () => (
  <section id="prefab" data-testid="prefab-section" className="bg-[#050505] px-6 py-24 md:px-12 md:py-32">
    <div className="mx-auto max-w-7xl">
      <SectionHead
        id="prefab"
        overline="Chapter 04 — Modern Construction"
        title="Prefabricated Houses — Faster. Smarter. Efficient."
        desc="Prefabricated construction brings engineering precision to home building — manufactured components, rapid assembly and contemporary design."
      />

      <div className="mt-14 grid grid-cols-1 gap-x-12 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">
        {PREFAB_BENEFITS.map((b, i) => (
          <Reveal key={b} delay={i * 0.05}>
            <div data-testid={`prefab-benefit-${i + 1}`} className="flex items-start gap-3 border-b border-white/10 py-4">
              <Check size={18} className="mt-0.5 shrink-0 text-[#0055FF]" />
              <span className="text-sm leading-relaxed text-[#D4D4D4]">{b}</span>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
        {PREFAB_CATEGORIES.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.1}>
            <div data-testid={`prefab-card-${i + 1}`} className="group relative overflow-hidden border border-white/10">
              <img
                src={c.img}
                alt={c.title}
                className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <h3 className="font-display text-xl font-bold tracking-tight">{c.title}</h3>
                <p className="mt-2 text-sm text-[#A3A3A3]">{c.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-12 flex justify-center">
          <a
            data-testid="prefab-discuss-button"
            href={whatsappHref()}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-3 border border-[#0055FF] px-8 py-4 font-display text-sm font-bold uppercase tracking-widest text-white transition-all hover:bg-[#0055FF]"
          >
            Discuss Your Prefabricated House
            <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
